"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _NoSsr.default;
  }
});

var _NoSsr = _interopRequireDefault(require("./NoSsr"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/NoSsr/index.js
// module id = 70
// module chunks = 0